import React from 'react';
import { ExpirationsProvider } from './context/ExpirationsUIContext';
import { Box, Card } from '@mui/material';
import ProductsDropMenu from '../../products/ProductsDropMenu';
import ExpirationsTable from './table/ExpirationsTable';
import ExpirationsHeader from './ExpirationsHeader';

export default function Collections () {
    return (
        <ExpirationsProvider>
            <Box display='flex' flexDirection='column' justifyContent='center' width='100%' marginRight={'2rem'}>
                <Box style={{ borderRadius: '4px', marginTop: '1rem', width: '100%', margin: '1rem 1rem 0 1rem' }}>
                    <Card sx={{ boxShadow: 'none' }}>
                        <ExpirationsHeader />
                    </Card>
                </Box>
                <div className='menuFlex'>
                    <div className='menuFlexLeft'>
                        <ProductsDropMenu />
                    </div>
                    <div className='menuFlexRight'>
                        <ExpirationsTable />
                    </div>
                </div>
            </Box>
        </ExpirationsProvider>
    );
}
